// /profile: the parent Profile (004 FR-001–FR-008; P-PROF-1..4). Log out and the theme choice live
// in its Settings section (002 FR-022, FR-024).
import { ProfileScreen } from "@/profile/ProfileScreen";

export default function Profile() {
  return <ProfileScreen />;
}
